import React from "react";

export const CustomTextarea = React.forwardRef(
	(
		{
			label,
			id,
			handleChange,
			value,
			error,
			errorText,
			theme,
			size,
			helper,
			hasHint,
			height = "h-[42px]",
			hint,
			required,
			labelType,
			acceptAlphabets = true,
			acceptNumbers = true,
			...rest
		},
		ref
	) => {
		function themeStyle() {
			return `text-[#1F2937] text-[13px] font-[400] border border-[#C9C9C9] focus:border-[#a3a3a3] outline-none mb-2 transition-all duration-300 ease-in-out ${height}`;
		}

		function handleSize(size) {
			if (size === "small") {
				return "p-2 text-xs";
			}
			return "p-3";
		}

		function handleKeyDown(event) {
			const key = event.key;

			const allowedKeys = [
				"Backspace",
				"ArrowLeft",
				"ArrowRight",
				"Tab",
				"Delete",
			];
			if (allowedKeys.includes(key)) {
				return;
			}

			if (!acceptAlphabets && /[a-zA-Z]/.test(key)) {
				event.preventDefault();
			}

			if (!acceptNumbers && /[0-9]/.test(key)) {
				event.preventDefault();
			}
		}

		return (
			<div className="w-full relative">
				{label && (
					<label
						className={`block ${
							error ? "text-[#FF3B30]" : "text-[#1E1E1E] dark:text-secondary"
						} ${
							labelType === "overlay"
								? "absolute bg-[white] dark:bg-dark top-[-11px] left-2 px-1"
								: ""
						} ${
							theme === "profile" ? "!text-[#00000080]" : ""
						} text-[12px] mb-1`}
						htmlFor={id}
					>
						{label} {required && <span className="text-[#FF3B30]">*</span>}
					</label>
				)}
				{hasHint && (
					<p className="absolute top-0 right-0 text-right group">
						<span className="cursor-pointer text-blue-900 text-sm">
							&#9432;
						</span>

						<span className="absolute z-10 p-2 text-white bg-blue-900 rounded-md -top-2 right-0 transform scale-0 group-hover:scale-100 origin-right transition-transform duration-200 text-tiny text-nowrap">
							{hint}
						</span>
					</p>
				)}
				<textarea
					className={`${
						error
							? `text-[#FF3B30] border border-[#FF3B30] focus:outline-[#FF3B30] ${height}`
							: themeStyle(theme)
					} w-full ${handleSize(
						size
					)} rounded-md bg-white dark:bg-dark dark:text-gray-100 text-[12px]`}
					ref={ref}
					id={id}
					value={value}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
					{...rest}
				/>
				{error && errorText && (
					<p className="text-[10px] text-[#FF3B30] mt-1">{errorText}</p>
				)}
				{helper && <p className="text-[10px] mt-1">{helper}</p>}
			</div>
		);
	}
);

CustomTextarea.displayName = "NativeInput";
